
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { DriverRechargeClient, DriverClient } from '@/api'
import _ from 'lodash'
import BaseEditor from '@/views/BaseEditor'
import { convertCurrency } from '@/utils'

@Component({
  name: 'CompanyRechargeEditor',
  components: {}
})
export default class extends BaseEditor {
  private driverList = [];
  private driverClient = new DriverClient();
  private driverFilter = '';
  public constructor() {
    super()
    this.client = new DriverRechargeClient()
    this.data = {}
    this.rules = {
      driverId: [{ required: true, message: '司机为必选项', trigger: 'blur' }],
      amount: [
        { required: true, message: '充值金额不能为空', trigger: 'blur' },
        {
          type: 'number',
          min: 0.01,
          max: 9999999,
          message: '充值金额必须在正常范围[0.01~9999999]',
          trigger: 'blur'
        }
      ],
      discount: [{ required: true, message: '折扣不能为空', trigger: 'blur' }]
    }
  }

  @Watch('driverFilter', { immediate: true, deep: true })
  onDriverFilterChanged(val: String, oldVal: String) {
    const driver: any = _.find(this.driverList, { mobile_phone_number: val })
    if (driver) {
      this.data.driverId = driver.id
    } else {
      this.data.driverId = undefined
    }
  }

  get smalltoBIG(): string {
    return convertCurrency(this.data.amount)
  }

  public async getData(id = -1) {
    await super.getData(id)
    await this.getDriverList()
  }

  private async getDriverList() {
    this.driverList = await this.driverClient.fetch({
      filter: {
        where: { isDeleted: false },
        fields: {
          id: true,
          name: true,
          mobile_phone_number: true
        },
        order: ['name']
      }
    })
  }

  public async reset() {
    this.data = {
      driverId: undefined,
      amount: undefined,
      discount: 1,
      description: undefined,
      status: 'waiting'
    }
  }

  protected generateData(): any {
    const data = _.pick(this.data, [
      'driverId',
      'amount',
      'discount',
      'description',
      'status'
    ])
    data.amount = Number(data.amount)
    data.discount = Number(data.discount)
    return this.clearData(data)
  }
}
